export const filterBarHeightMobile = '60px';
export const filterBarHeight = '80px';
export const filterBarHeightWithTiles = '158px';
export const headerHeight = '60px';
export const bannerHeight = '55px';

export const breakpoints = {
  MAP_CAN_SHOW: 1152,
  BOATS_TWO_COLS: 770,
  BOATS_THREE_COLS: 1920,
  BOATS_FOUR_COLS: 2560,
  QUICK_FILTER_BOTTOM_SHEET_MAX: 450,
};
